const checkBankMaintenanceTime = () => {
  const date = new Date();
  const hour = date.getHours();
  const minutes = date.getMinutes();

  /* 은행 공동망 점검 시간(23:50 ~ 24:30)일 경우 */
  if ((hour === 23 && minutes >= 50) || (hour === 0 && minutes <= 30)) {
    return true;
  }

  return false;
};

export default checkBankMaintenanceTime;
